import { DbInsertInventory } from "../../../data/usecases/insert-inventory";
import { InsertInventory } from "../../../domain/usecases/insert-inventory";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl } from "../http";

export const makeDbInsertInventory = (): InsertInventory =>
  new DbInsertInventory(
    makeApiUrl("/inventory/insert"),
    makeAuthorizeHttpClientDecorator()
  );
